var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSocialTwitter = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icon-SocialTwitter"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.3332 3.92959C14.7934 4.14361 14.2132 4.28836 13.6049 4.35325C14.2271 4.02001 14.7041 3.4928 14.9278 2.86424C14.346 3.17269 13.7031 3.39655 13.0162 3.5165C12.4691 2.99331 11.6861 2.66663 10.8203 2.66663C9.15932 2.66663 7.81202 3.87235 7.81202 5.35918C7.81202 5.57065 7.83769 5.77555 7.88984 5.97243C5.38958 5.85977 3.17247 4.78895 1.68706 3.15883C1.42795 3.5577 1.28047 4.02001 1.28047 4.51368C1.28047 5.44705 1.81173 6.2714 2.61839 6.75486C2.12624 6.74137 1.66139 6.61923 1.2548 6.4187V6.45151C1.2548 7.75714 2.29247 8.84546 3.6695 9.09193C3.41732 9.155 3.1521 9.18672 2.87669 9.18672C2.68276 9.18672 2.49413 9.17068 2.3108 9.13896C2.69376 10.2087 3.80395 10.9875 5.1215 11.0083C4.09117 11.7309 2.79317 12.1611 1.38436 12.1611C1.14154 12.1611 0.901578 12.1491 0.666504 12.1239C1.99832 12.8874 3.57987 13.3333 5.27836 13.3333C10.8146 13.3333 13.84 9.23084 13.84 5.672C13.84 5.55497 13.8376 5.4383 13.8319 5.32345C14.4202 4.94354 14.9315 4.4692 15.3332 3.92959Z",
  fill: "#142138"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSocialTwitter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-SocialTwitter.da40bb1f48f0955d0d8e7aa818a32366.svg";